// Lib
import gql from 'graphql-tag';

/* Org messaging (S1 + S2). Written by hand: the schema isn't deployed yet, so
 * these aren't in src/types/graphql.ts — local types live in
 * @modules/Inbox/types. */

export const THREAD_FIELDS = `
  _id
  subject
  authId
  externalEmail
  externalName
  counterpart {
    kind
    organizationId
    name
    email
    avatarUrl
    organizationType
  }
  lastMessageAt
  lastMessagePreview
  createdAt
  seq
  unreadCount
`;

export const THREAD_MESSAGE_FIELDS = `
  _id
  threadId
  seq
  direction
  source
  body
  authorAccountId
  authorName
  deliveryStatus
  createdAt
`;

export const threadsQuery = gql`
  query Threads($input: ListThreadsInput!) {
    threads(input: $input) {
      total
      hasMore
      cursor
      items {
        ${THREAD_FIELDS}
      }
    }
  }
`;

export const threadQuery = gql`
  query Thread($id: ID!) {
    thread(id: $id) {
      ${THREAD_FIELDS}
    }
  }
`;

export const threadMessagesQuery = gql`
  query ThreadMessages($threadId: ID!) {
    threadMessages(threadId: $threadId) {
      ${THREAD_MESSAGE_FIELDS}
    }
  }
`;

/** Threads with unread messages for the current account (sidebar badge). */
export const unreadThreadsCountQuery = gql`
  query UnreadThreadsCount {
    unreadThreadsCount
  }
`;
